import type { DocumentResponse } from '@onefootprint/request-types';

/**
 * The vendor's codes for why a capture was refused, as one comparable string. errorDetails is what
 * the retry screen renders, but some responses populate only the flat errors list, so fall back to
 * it rather than recording no reason at all.
 *
 * A codeless detail is labelled `custom_error`, matching what the processing pages render for the
 * same detail, so a log line names the screen the user actually saw.
 */
const getRejectionCodes = ({ errorDetails, errors }: Pick<DocumentResponse, 'errorDetails' | 'errors'>): string =>
  (errorDetails?.length ? errorDetails.map(detail => detail.code ?? 'custom_error') : (errors ?? [])).join(',');

export default getRejectionCodes;
